import React, { Fragment, memo } from 'react';
import { useForm } from 'react-hook-form';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { UserDTO } from '@app/common';
import { Button, Form, Panel } from '@app/components';
import { UserForm } from './UserForm';
import { useToast, useTriptych } from '@app/hooks';
import { UserCard } from './UserCard';
import { transformUserFormValuesToPayload, UserFormValues } from './user-form.helpers';
import { userApi } from '@app/store';

export const UserCreate = memo(() => {
  const toast = useToast();

  const triptych = useTriptych()

  const [create, { isLoading, error: apiErrors }] = userApi.useCreateOneUsersMutation();

  const formMethods = useForm<UserFormValues>({
    resolver: classValidatorResolver(UserDTO),
    defaultValues: {
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      shops: [],
      roles: [],
      code: '',
      isDeleted: false,
    },
  });

  const onCreate = async (formValues: UserFormValues) => {
    try {
      const user = await create(transformUserFormValuesToPayload(formValues)).unwrap();

      triptych.close({ mode: 'UPDATE', data: user });

      toast.success('Votre utilisateur a bien été ajouté.')
    } catch {
      toast.error('Une erreur est survenue lors de la création de votre utilisateur.')
    }
  }

  return (
    <Fragment>
      <UserCard
        formMethods={formMethods}
        toggle={() => triptych.toggle()} />

      <Form formMethods={formMethods} apiErrors={apiErrors}>

        <Panel.Content>

          <Panel.FormContainer>

            <UserForm />

          </Panel.FormContainer>

          <Panel.Actions>
            <Button
              title="Retour"
              grow
              large
              bordered
              onPress={() => triptych.close()} />

            <Button
              title="Valider"
              loading={isLoading}
              onPress={formMethods.handleSubmit(onCreate)}
              grow
              large />
          </Panel.Actions>

        </Panel.Content>

      </Form>

    </Fragment>
  );
});
